

import { Helmet } from 'react-helmet-async';

import { HOMEPAGE_FAQS } from '../../data/homepageFaqs';
import './HomePage.css';

// Keep critical above-the-fold CSS eager (see FulfillmentBox).
import './FulfillmentBox.css';

import Canonical from '../../seo/Canonical';

import FulfillmentBox from './FulfillmentBox';
import TopHero from './TopHero';
import HomeHeroSection from './HomeHeroSection';
import BrandWhySection from './BrandWhySection';
import StatsSection from './StatsSection';
import Process from './process';
import Slider from './Slider';
import WhyChooseUs from './whychooseus';
import SfpComparisonSection from './SfpComparisonSection';
import Industries from './Industries';
import ExploreSection from './ExploreSection';
import DeferredTestimonials from './DeferredTestimonials';
import Contact from './ContactUs';
import CareersSection from './CareersSection';
import DeferredHomepageFaqs from './DeferredHomepageFaqs';
import DeferredNewsletter from './DeferredNewsletter';
import Footer from '../Layouts/Footer';




const HomePage: React.FC = () => {

  const faqSchema = {
    "@context": "https://schema.org", "@type": "FAQPage",
    "mainEntity": HOMEPAGE_FAQS.map((faq) => ({
      "@type": "Question", "name": faq.question,
      "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
    }))
  };

  const localBusinessSchema = {
    "@context": "https://schema.org", "@type": "LocalBusiness",
    "name": "Pick Pack Pro",
    "image": "https://www.pickpackpro.co.uk/Images/ppp-orange-Blue-logo.webp",
    "address": { "@type": "PostalAddress", "streetAddress": "Unit 36, Tanners Drive, Blakelands", "addressLocality": "Milton Keynes", "postalCode": "MK14 5BN", "addressCountry": "GB" },
    "telephone": "+44-7404-049714", "email": "info@pickpackpro.co.uk",
    "url": "https://www.pickpackpro.co.uk/",
    "sameAs": ["https://www.linkedin.com/company/pickpackpro/", "https://www.instagram.com/pick_pack_pro/", "https://www.facebook.com/people/Pick-Pack-Pro/61576991261226/"],
    "aggregateRating": { "@type": "AggregateRating", "ratingValue": "5.0", "reviewCount": "8" }
  };

  return (
    <div className="site-root">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
      </Helmet>
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />
      <TopHero />

      <StatsSection />
      <FulfillmentBox />
      <HomeHeroSection />
      <BrandWhySection />
      <Process />
      <Slider />
      <WhyChooseUs />
      <SfpComparisonSection />
      <Industries />

      <ExploreSection />

      <DeferredTestimonials />
      <Contact />
      <CareersSection />
      <DeferredHomepageFaqs />
      <DeferredNewsletter />
      <Footer />
    </div>
  );
};

export default HomePage;



